import React from 'react'
import { translate } from 'react-polyglot'
import { Field, reduxForm, change as changeFieldValue } from 'redux-form'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import {
	Form,
	ButtonGroup,
	Button,
	Avatar,
	FlexContainer,
	Text,
	ColorSwitch,
	ImagePreview,
	Modal,
} from 'components'
import { Text as TextField, Url } from 'components/FormField'
import { required } from 'utils/validation'

const TeamForm = ({
	handleSubmit,
	error,
	t,
	teamImage,
	teamImageUploadPending,
	teamImageUploadSuccessful,
	onUploadTeamImage,
	teamLogo,
	teamLogoUploadPending,
	teamLogoUploadSuccessful,
	onUploadTeamLogo,
	teamLogoNegative,
	teamLogoNegativeUploadPending,
	teamLogoNegativeUploadSuccessful,
	onUploadTeamLogoNegative,
	teamFavicon,
	teamFaviconUploadPending,
	teamFaviconUploadSuccessful,
	onUploadTeamFavicon,
	teamColorScheme,
	onChangeTeamColorScheme,
	onToggleChangeSlugModal,
	...props
}) => (
	<>
		<Form onSubmit={handleSubmit} error={error}>
			<FlexContainer
				className="c-form__fieldwrap"
				justifyContent="flex-start"
			>
				<a
					href="#"
					onClick={e => {
						e.preventDefault()

						document.getElementById('team-image-input').click()
					}}
				>
					<Avatar size="large" image={teamImage} />
				</a>
				<Text color="dark">
					<ButtonGroup orientation="horizontal">
						<input
							id="team-image-input"
							type="file"
							accept="image/jpeg,image/png,image/gif,image/svg+xml,image/bmp,image/tiff"
							onChange={onUploadTeamImage}
							className="u-visually-hidden"
						/>
						<Button
							text={t('forms.update_team_image')}
							size="small"
							layout="ghosted"
							onClick={() => {
								document
									.getElementById('team-image-input')
									.click()
							}}
							showFeedback
							isLoading={teamImageUploadPending}
							wasSuccessful={teamImageUploadSuccessful}
						/>
						{/* <Button
						icon={<Icon name="delete" />}
						size="small"
					/> */}
					</ButtonGroup>
					<br />
					<small>{t('forms.image_requirements')}</small>
				</Text>
			</FlexContainer>
			<Field
				name="teamName"
				label={t('forms.team_name')}
				component={TextField}
				validate={[required]}
				required
				onChange={async e => {
					await props.changeFieldValue(
						'team',
						'teamName',
						e.target.value
					)

					handleSubmit()
				}}
			/>
			<Field
				name="teamUrl"
				label={t('forms.team_url')}
				component={Url}
				validate={[required]}
				disabled
				button={
					<Button
						text={t('change')}
						size="small"
						layout="text"
						onClick={onToggleChangeSlugModal}
					/>
				}
			/>
		</Form>
		<h2>{t('settings.customize_appearance_title')}</h2>
		<Text>{t('settings.customize_appearance_text')}</Text>

		<h4>{t('settings.company_logo_title')}</h4>
		<FlexContainer
			className="c-form__fieldwrap"
			justifyContent="flex-start"
			alignItems="flex-start"
		>
			<a
				href="#"
				onClick={e => {
					e.preventDefault()

					document.getElementById('team-logo-input').click()
				}}
			>
				<ImagePreview
					image={teamLogo}
					format="panorama"
					background="light"
				/>
			</a>
			<Text color="dark">
				<ButtonGroup orientation="horizontal">
					<input
						id="team-logo-input"
						type="file"
						accept="image/jpeg,image/png,image/gif,image/svg+xml,image/bmp,image/tiff"
						onChange={onUploadTeamLogo}
						className="u-visually-hidden"
					/>
					<Button
						text={t('settings.upload_logo')}
						size="small"
						layout="ghosted"
						onClick={() => {
							document.getElementById('team-logo-input').click()
						}}
						showFeedback
						isLoading={teamLogoUploadPending}
						wasSuccessful={teamLogoUploadSuccessful}
					/>
					{/* <Button
					icon={<Icon name="delete" />}
					size="small"
				/> */}
				</ButtonGroup>
				<br />
				<small>{t('settings.logo_light_requirements')}</small>
			</Text>
		</FlexContainer>

		<h4>{t('settings.company_logo_neg_title')}</h4>
		<FlexContainer
			className="c-form__fieldwrap"
			justifyContent="flex-start"
			alignItems="flex-start"
		>
			<a
				href="#"
				onClick={e => {
					e.preventDefault()

					document.getElementById('team-logo-negative-input').click()
				}}
			>
				<ImagePreview
					image={teamLogoNegative}
					format="panorama"
					background="dark"
				/>
			</a>
			<Text color="dark">
				<ButtonGroup orientation="horizontal">
					<input
						id="team-logo-negative-input"
						type="file"
						accept="image/jpeg,image/png,image/gif,image/svg+xml,image/bmp,image/tiff"
						onChange={onUploadTeamLogoNegative}
						className="u-visually-hidden"
					/>
					<Button
						text={t('settings.upload_logo')}
						size="small"
						layout="ghosted"
						onClick={() => {
							document
								.getElementById('team-logo-negative-input')
								.click()
						}}
						showFeedback
						isLoading={teamLogoNegativeUploadPending}
						wasSuccessful={teamLogoNegativeUploadSuccessful}
					/>
					{/* <Button
					icon={<Icon name="delete" />}
					size="small"
				/> */}
				</ButtonGroup>
				<br />
				<small>{t('settings.logo_dark_requirements')}</small>
			</Text>
		</FlexContainer>

		<h4>{t('settings.favicon_title')}</h4>
		<FlexContainer
			className="c-form__fieldwrap"
			justifyContent="flex-start"
			alignItems="flex-start"
		>
			<a
				href="#"
				onClick={e => {
					e.preventDefault()

					document.getElementById('team-favicon-input').click()
				}}
			>
				<ImagePreview image={teamFavicon} />
			</a>
			<Text color="dark">
				<ButtonGroup orientation="horizontal">
					<input
						id="team-favicon-input"
						type="file"
						accept="image/jpeg,image/png,image/gif,image/bmp,image/tiff"
						onChange={onUploadTeamFavicon}
						className="u-visually-hidden"
					/>
					<Button
						text={t('settings.upload_favicon')}
						size="small"
						layout="ghosted"
						onClick={() => {
							document
								.getElementById('team-favicon-input')
								.click()
						}}
						showFeedback
						isLoading={teamFaviconUploadPending}
						wasSuccessful={teamFaviconUploadSuccessful}
					/>
					{/* <Button
					icon={<Icon name="delete" />}
					size="small"
				/> */}
				</ButtonGroup>
				<br />
				<small>{t('settings.favicon_requirements')}</small>
			</Text>
		</FlexContainer>
		<h4>{t('settings.color_title')}</h4>
		<FlexContainer
			className="c-form__fieldwrap"
			justifyContent="flex-start"
		>
			<ColorSwitch
				value="default"
				name="color"
				defaultChecked={teamColorScheme === 'default'}
				onChange={() => onChangeTeamColorScheme('default')}
			/>
			<ColorSwitch
				value="green"
				name="color"
				defaultChecked={teamColorScheme === 'green'}
				onChange={() => onChangeTeamColorScheme('green')}
			/>
			<ColorSwitch
				value="yellow"
				name="color"
				defaultChecked={teamColorScheme === 'yellow'}
				onChange={() => onChangeTeamColorScheme('yellow')}
			/>
			<ColorSwitch
				value="red"
				name="color"
				defaultChecked={teamColorScheme === 'red'}
				onChange={() => onChangeTeamColorScheme('red')}
			/>
			<ColorSwitch
				value="blue"
				name="color"
				defaultChecked={teamColorScheme === 'blue'}
				onChange={() => onChangeTeamColorScheme('blue')}
			/>
			<ColorSwitch
				value="orange"
				name="color"
				defaultChecked={teamColorScheme === 'orange'}
				onChange={() => onChangeTeamColorScheme('orange')}
			/>
			<ColorSwitch
				value="neutral"
				name="color"
				defaultChecked={teamColorScheme === 'neutral'}
				onChange={() => onChangeTeamColorScheme('neutral')}
			/>
		</FlexContainer>
	</>
)

const mapDispatchToProps = dispatch =>
	bindActionCreators({ changeFieldValue }, dispatch)

export default connect(
	null,
	mapDispatchToProps
)(
	reduxForm(
		{
			form: 'team',
		},
		mapDispatchToProps
	)(translate()(TeamForm))
)
